import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CurrentPlatform, TextSizes, TextType } from 'src/app/shared/enums';
import { UtilsService } from '../../services/utils.service';
import { GetFilePicturePipe } from '../../pipe/get-file-picture/get-file-picture.pipe';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { TextComponent } from '../text/text.component';
import { SvgComponent } from '../svg/svg.component';
import { IonicModule } from '@ionic/angular';
@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  imports: [NgClass, NgTemplateOutlet, TextComponent, SvgComponent, IonicModule],
})
export class FileUploadComponent {
  private _utilsService = inject(UtilsService);
  private _getFilePicture = inject(GetFilePicturePipe);

  @Input() mode = '';

  @Input() fileTitle: string | undefined;

  @Input() fileSubtitle: number | string | undefined = '';

  @Input() isRemoved = false;

  @Input() isLoading = false;

  @Input() type: string | undefined;

  @Input() itemId: number | undefined;

  @Input() postFileView: boolean | undefined;

  @Input() inFavouritesList: boolean | undefined;

  @Input() filePath: string | undefined;

  @Input() currentPlatform: CurrentPlatform | null = null;

  @Input() isDisabled = false;

  @Output() deleteItem = new EventEmitter<string | undefined>();

  @Output() changeFavouritesStatus = new EventEmitter<string | undefined>();

  public readonly TextSizes = TextSizes;

  public readonly TextType = TextType;

  handleDeleteItem(itemId: number | undefined) {
    this.deleteItem.emit(itemId?.toString());
  }

  handleChangeFavouritesStatus(itemId: number | undefined) {
    this.changeFavouritesStatus.emit(itemId?.toString());
  }

  public downloadFile() {
    if (this.type !== 'poll' && this.mode !== 'create') {
      this._utilsService.downloadFile(this.fileTitle, this.filePath);
    }
  }

  public async openLinkMob() {
    if (this.filePath) {
      await this._utilsService.openUrlInBrowser(this.filePath);
    }
  }

  public getFilePreview(isMobile: boolean) {
    if (this.type === 'poll') {
      return 'assets/images/icons-svg/post-creation/poll-to-upload.svg';
    }

    return this.isRemoved
      ? 'assets/images/icons-svg/deleted-file-template.svg'
      : this._getFilePicture.transform(this.fileTitle, isMobile);
  }
}
